module.exports = __webpack_public_path__ + "img/1726035140801-screenshot-1726035103445.png.f15ccd30.webp";